import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AfterViewInit, ChangeDetectorRef, Component, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';

import { DatePipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../services/http.service';
import { URLUtils } from '../urlUtils';
import { XmppService } from '../services/xmpp.service';
import { environment } from 'src/environments/environment';

import { SessionService } from '../services/session_service';
import { SidebarService } from '../services/sidebar.service';
import { Subscription } from 'rxjs';
declare var bootstrap: any;

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  categoryName: string = "Dashboard";
  name: string = "";
  role: string = "";
  roleId: string = "TM";
  product = environment.product;

  /**
   * ── PRODUCT BRAND CONFIG ──────────────────────────────────────────────────
   * Add / edit products here.  Each entry needs:
   *   logo     – full-width logo shown in the expanded sidebar header
   *   logoIcon – small square / icon variant shown when sidebar is collapsed
   *   name     – human-readable product name shown next to the logo
   * ─────────────────────────────────────────────────────────────────────────
   */
  private readonly PRODUCT_CONFIG: Record<string, { logo: string; logoIcon: string; name: string }> = {
    lauditor: {
      logo: '/assets/img/MLexiZ-LawyerTP3.png',
      logoIcon: '/assets/img/WEBLOGOV3.png',
      name: 'Lex-Z Lawyers',
    },
    corporate: {
      logo: 'assets/img/MLexiZ-CorporateTP.png',
      logoIcon: 'assets/img/MLexiZ-CorporateTP.png',
      name: 'Lex-Z Corporate',
    },
    content: {
      logo: '/assets/site/images/contentcoffer-logo.png',
      logoIcon: '/assets/site/images/contentcoffer-logo.png',
      name: 'Content Coffer',
    },
    connect: {
      logo: '/assets/site/images/cofferconnect-logo.png',
      logoIcon: '/assets/site/images/cofferconnect-logo.png',
      name: 'Coffer Connect',
    },
  };

  /** Returns the brand config for the active product (falls back to lauditor). */
  get currentProduct() {
    return this.PRODUCT_CONFIG[this.product] ?? this.PRODUCT_CONFIG['lauditor'];
  }

  key: any;
  activeItemId: string | null = null;
  selectedItem: string | null = null;
  switchableFirms: any[] = [];
  hasMultipleFirms: boolean = false;
  dateSet: any = new Date();
  day: any = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
  dateTime: any = this.dateSet.getHours();
  date: any = this.day[this.dateSet.getDate()];
  time = new Date();
  minute: any = this.dateSet.getMinutes();
  ampm: string = this.time.getHours() >= 12 ? 'PM' : 'AM';
  timer: any;
  /** Formatted time string shown in the header user-info block (e.g. "09:15 AM") */
  currentTime: string = '';
  isCardVisible = false;
  groups: any;
  availableFirms: any[] = [];  // List of firms to display in Switch Firms
  currentFirmIndex: number = 0;  // Track current selected firm
  isSwitchingFirm: boolean = false;  // Loading state during firm switch
  profile: any;
  useremail: any;
  notificationCount: number = 0;
  private routerSub: any;
  private notificationIntervalId: any = null;
  isLoadingSwitchFirm: boolean = false;
  switchingFirmId: string = '';
  currentFirmId: string = '';
  firmName: string = '';
  AAM_email: string = '';
  profilePic: any;
  plan: any;
  category: any;
  originalNavItems: any;
  isSoloCategory: boolean = false;

  isSidebarCollapsed: boolean = false;
  private sidebarRequestSub?: Subscription;
  isMobileMenuOpen: boolean = false;
  expandedItem: string | null = null;
  tooltipVisible: boolean = false;
  tooltipText: string = '';
  tooltipTop: number = 0;
  tooltipLeft: number = 0;
  submenuPopoverVisible: boolean = false;
  popoverTitle: string = '';
  popoverItems: any[] = [];
  popoverTop: number = 0;
  popoverLeft: number = 0;
  private popoverTimeout: any;
  activeNavItems: any[] = [];
  expandedNestedItem: string | null = null;

  navItem = [
    {
      name: 'My Profile',
      roles: ['AAM', 'TM', 'GH', 'SU'],
      id: 'profile', link: '/profile', image: 'assets/img/Firmprofile.svg', class: '',
      icon: 'person',
      module: ['profile']
    },
    {
      name: 'Appointments',
      roles: ['TM', 'SU', 'GH'],
      id: 'appointments', link: '/appointments', image: 'assets/img/appointments-module.svg', class: '',
      icon: 'event',
      module: ['appointments']
    },
    {
      name: 'Matters',
      roles: ['TM', 'GH', 'SU'],
      id: 'matters', 
      link: '/matter/legalmatter/view', 
      image: 'assets/img/Matters.svg', class: '',
      icon: 'work',
      module: ['matter'],
      children: [
        { label: 'Legal Matters', route: '/matter/legalmatter/view', category: 'LegalMatters', activeId: 'legalmatter' },
        { label: 'General Matters', route: '/matter/generalmatter/view', category: 'GeneralMatters', activeId: 'generalmatter' }
      ]
    },
    {
      name: 'Documents',
      roles: ['TM', 'GH', 'SU'],
      id: 'documents', link: '/documents/view/client', image: 'assets/img/Document.svg', class: '',
      icon: 'description',
      module: ['documents'],
      children: [
        { label: 'Matter', route: '/documents/view/matter', category: 'Matter Documents', activeId: 'doc-matter' },
        { label: 'Client', route: '/documents/view/client', category: 'Client Documents', activeId: 'doc-client' },
        { label: 'Firm', route: '/documents/view/firm', category: 'Firm Documents', activeId: 'doc-firm' },
        { label: 'Deleted', route: '/documents/view/delete', category: 'Deleted Documents', activeId: 'doc-delete' }
      ]
    },
    // {
    //   name: 'Merge PDF',
    //   roles: ['TM', 'GH', 'SU'],
    //   id: 'merge pdf',
    //   link: '/mergepdf',
    //   image: 'assets/img/merge-pdf.svg',
    //   class: '',
    //   icon: 'picture_as_pdf',
    //   module: ['mergepdf']
    // },
    {
      name: 'Doc Editor',
      roles: ['TM', 'GH', 'SU'],
      id: 'doc editor', link: '/doceditor', image: 'assets/img/docedi.svg', class: '',
      icon: 'edit_document',
      module: ['doceditor', 'doceditor']
    }, // new c

    // {
    //   name: 'Doc Editor',
    //   roles: ['TM', 'GH', 'SU'],
    //   id: 'doc editor', link: '/doceditor', image: 'assets/img/docedi.svg', class: '',
    //   icon: 'edit_document',
    //   module: ['doceditor', 'viewdoc'],
    //   children: [
    //     { label: 'Create', route: '/doceditor', category: 'Document Editor', activeId: 'doceditor-create' },
    //     { label: 'View', route: '/viewdoc', category: 'View Document', activeId: 'doceditor-view' }
    //   ]
    // },
    {
      name: 'Relationships',
      roles: ['TM', 'GH', 'SU'],
      id: 'relationships', link: '/relationship/view/individuals', image: 'assets/img/relationship.svg', class: '',
      icon: 'people',
      module: ['relationship'],
      children: [
        { label: 'Individual', route: '/relationship/view/individuals', category: 'Individuals', activeId: 'individuals' },
        { label: 'Business', route: '/relationship/view/business', category: 'Business', activeId: 'business' },
        { label: 'Corporate', route: '/relationship/view/corporate', category: 'Corporate', activeId: 'corporate' },
        { label: 'Deleted', route: '/relationship/view/deleted', category: 'Deleted', activeId: 'deleted' }
      ]
    },
    {
      name: 'Timesheets',
      roles: ['TM', 'GH', 'SU'],
      id: 'timesheets', link: '/timesheets/non-submitted', image: 'assets/img/timesheet.svg', class: '',
      icon: 'schedule',
      module: ['timesheets'],
      // children: [
      //   { label: 'Aggregated Timesheet', route: '/timesheets/aggregate-members', category: 'AggregatedTimesheet', activeId: 'aggregate' },
      //   { label: 'My Timesheet', route: '/timesheets/non-submitted', category: 'MyTimesheet', activeId: 'non-submitted' }
      // ]
    },
    {
      name: 'Invoices',
      roles: ['GH', 'SU', 'TM'],
      id: 'invoices', link: '/invoice', image: 'assets/img/invoice.svg', class: '',
      icon: 'receipt',
      module: ['invoice', 'invoice']
    },
    {
      name: 'Meetings',
      roles: ['TM', 'GH', 'SU', 'AAM'],
      id: 'meetings', link: '/meetings/view', image: 'assets/img/meeting.svg', class: '',
      icon: 'event_note',
      module: ['meetings']
    },
    // {
    //   name: 'Emails',
    //   roles: ['TM', 'GH', 'SU', 'AAM'],
    //   id: 'emails', link: '/emails', image: 'assets/img/email.svg', class: '',
    //   icon: 'email',
    //   module: ['emails']
    // },
    {
      name: 'Messages',
      roles: ['TM', 'GH', 'SU', 'AAM'],
      id: 'messages', link: '/messages/clients', image: 'assets/img/messages.svg', class: '',
      icon: 'chat',
      //module: ['messages'],
       module: ['messages']
      // children: [
      //   { label: 'Clients', route: '/messages/clients', category: 'Messages - Clients', activeId: 'msg-clients' },
      //   { label: 'Teams', route: '/messages/teams', category: 'Messages - Teams', activeId: 'msg-teams' }
      // ]
    },
    {
      name: 'Notifications',
      roles: ['TM', 'GH', 'SU', 'AAM'],
      id: 'notifications', link: '/notifications', image: 'assets/img/notification.svg', class: '',
      icon: 'notifications',
      module: ['notifications']
    },
    {
      name: 'Settings',
      roles: ['TM', 'GH', 'SU', 'AAM'],
      id: 'settings', link: '/settings', image: 'assets/img/settings.svg', class: '',
      icon: 'settings',
      module: ['settings']
    },
    {
      name: 'Audit Trails',
      roles: ['GH', 'SU', 'AAM'],
      id: 'audit trails', link: '/audit', image: 'assets/img/audits.svg', class: '',
      icon: 'history',
      module: ['audit']
    },
    {
      name: 'Groups',
      roles: ['SU', 'AAM', 'GH'],
      id: 'groups', link: '/groups/view-group', image: 'assets/img/total.svg', class: '',
      icon: 'groups',
      module: ['groups']
    },
    {
      name: 'Members',
      roles: ['SU', 'AAM', 'GH'],
      id: 'members', link: '/groups/view-member', image: 'assets/img/total.svg', class: '',
      icon: 'person_add',
      module: ['members']
    },
    //   roles: ['AAM', 'GH', 'SU', 'TM'],
    //   id: 'payments', link: '/payment', image: 'assets/img/invoice.svg', class: '',
    //   icon: 'payments'
    // }
  ]

  navCorporate = [
    {
      name: 'Profile',
      roles: ['AAM', 'SU'],
      id: 'profile', link: '/profile', image: 'assets/img/Firmprofile.svg', class: '',
      icon: 'person',
      module: ['profile']
    },
    // {
    //   name: 'Appointments',
    //   roles: ['TM','SU','GH'],
    //   id: 'appointments', link: '/appointments', image: 'assets/img/appointments-module.svg', class: '',
    //   icon: 'event',
    //   module: ['appointments']
    // },
    {
      name: 'Matters',
      roles: ['TM', 'GH', 'SU'],
      id: 'matters', link: null, image: 'assets/img/Matters.svg', class: '',
      icon: 'work',
      module: ['matter'],
      children: [
        { label: 'Legal Matters', route: '/matter/legalmatter/view', category: 'LegalMatters', activeId: 'legalmatter' },
        { label: 'General Matters', route: '/matter/generalmatter/view', category: 'GeneralMatters', activeId: 'generalmatter' }
      ]
    },
    {
      name: 'Documents',
      roles: ['TM', 'GH', 'SU'],
      id: 'documents', link: null, image: 'assets/img/Document.svg', class: '',
      icon: 'description',
      module: ['documents'],
      children: [
        // { label: 'Matter',  route: '/documents/view/matter',  category: 'Matter Documents',  activeId: 'doc-matter' },
        // { label: 'Client',  route: '/documents/view/client',  category: 'Client Documents',  activeId: 'doc-client' },
        { label: 'Departments', route: '/documents/view/firm', category: 'Departments Documents', activeId: 'doc-firm' },
        // { label: 'Delete',  route: '/documents/view/delete',  category: 'Deleted Documents', activeId: 'doc-delete' }
      ]
    },
    // {
    //   name: 'Merge PDF',
    //   roles: ['TM', 'GH', 'SU'],
    //   id: 'merge pdf',
    //   link: '/mergepdf',
    //   image: 'assets/img/merge-pdf.svg',
    //   class: '',
    //   icon: 'picture_as_pdf',
    //   module: ['mergepdf']
    // },
    // {
    //   name: 'Doc Editor',
    //   roles: ['TM', 'GH', 'SU'],
    //   id: 'doc editor', link: '/doceditor', image: 'assets/img/docedi.svg', class: '',
    //   icon: 'edit_document',
    //   module: ['doceditor', 'viewdoc']
    // },
    {
      name: 'Relationships',
      roles: ['TM', 'GH', 'SU'],
      id: 'relationships', link: null, image: 'assets/img/relationship.svg', class: '',
      icon: 'people',
      module: ['relationship'],
      children: [
        { label: 'Individuals', route: '/relationship/view/individuals', category: 'Individuals', activeId: 'individuals' },
        { label: 'Business', route: '/relationship/view/business', category: 'Business', activeId: 'business' },
        { label: 'Corporate', route: '/relationship/view/corporate', category: 'Corporate', activeId: 'corporate' },
        { label: 'Deleted', route: '/relationship/view/deleted', category: 'Deleted', activeId: 'deleted' }
      ]
    },
    {
      name: 'Timesheets',
      roles: ['TM', 'GH', 'SU'],
      id: 'timesheets', link: null, image: 'assets/img/timesheet.svg', class: '',
      icon: 'schedule',
      module: ['timesheets'],
      children: [
        { label: 'Aggregated Timesheet', route: '/timesheets/aggregate-members', category: 'AggregatedTimesheet', activeId: 'aggregate' },
        { label: 'My Timesheet', route: '/timesheets/non-submitted', category: 'MyTimesheet', activeId: 'non-submitted' }
      ]
    },
    {
      name: 'Meetings',
      roles: ['TM', 'GH', 'SU', 'AAM'],
      id: 'meetings', link: '/meetings/view', image: 'assets/img/meeting.svg', class: '',
      icon: 'event_note',
      module: ['meetings']
    },
    {
      name: 'Emails',
      roles: ['TM', 'GH', 'SU', 'AAM'],
      id: 'emails', link: '/emails', image: 'assets/img/email.svg', class: '',
      icon: 'email',
      module: ['emails']
    },
    {
      name: 'Messages',
      roles: ['TM', 'GH', 'SU', 'AAM'],
      id: 'messages', link: null, image: 'assets/img/messages.svg', class: '',
      icon: 'chat',
      module: ['messages'],
      children: [
        { label: 'Clients', route: '/messages/clients', category: 'Messages - Clients', activeId: 'msg-clients' },
        { label: 'Teams', route: '/messages/teams', category: 'Messages - Teams', activeId: 'msg-teams' }
      ]
    },
    {
      name: 'Notifications',
      roles: ['TM', 'GH', 'SU', 'AAM'],
      id: 'notifications', link: '/notifications', image: 'assets/img/notification.svg', class: '',
      icon: 'notifications',
      module: ['notifications']
    },
    {
      name: 'Audit Trails',
      roles: ['GH', 'SU', 'AAM'],
      id: 'audit trails', link: '/audit', image: 'assets/img/audits.svg', class: '',
      icon: 'history',
      module: ['audit']
    },
    {
      name: 'Departments',
      roles: ['SU', 'AAM', 'GH'],
      id: 'groups', link: '/groups/view-group', image: 'assets/img/total.svg', class: '',
      icon: 'groups',
      module: ['groups']
    },
    {
      name: 'Members',
      roles: ['SU', 'AAM'],
      id: 'members', link: '/groups/view-member', image: 'assets/img/total.svg', class: '',
      icon: 'person_add',
      module: ['member']
    },
  ]

  navContent = [
    {
      name: 'Firm Profile',
      roles: ['AAM'],
      id: 'firm profile', link: '/profile', image: 'assets/img/Firmprofile.svg', class: '',
      icon: 'person',
      module: ['profile']
    },
    {
      name: 'Documents',
      roles: ['TM', 'GH', 'SU'],
      id: 'documents', link: '/documents', image: 'assets/img/Document.svg', class: '',
      icon: 'description',
      module: ['documents']
    },
    // {
    //   name: 'Doc Editor',
    //   roles: ['TM', 'GH', 'SU'],
    //   id: 'doc editor', link: '/doceditor', image: 'assets/img/docedi.svg', class: '',
    //   icon: 'edit_document',
    //   module: ['doceditor']
    // },
    {
      name: 'Relationships',
      roles: ['TM', 'GH', 'SU'],
      id: 'relationships', link: '/relationship/add/entity', image: 'assets/img/relationship.svg', class: '',
      icon: 'people',
      module: ['relationship']
    },
    {
      name: 'Meetings',
      roles: ['TM', 'GH', 'SU', 'AAM'],
      id: 'meetings', link: '/meetings/create', image: 'assets/img/meeting.svg', class: '',
      icon: 'event_note',
      module: ['meetings']
    },
    {
      name: 'Emails',
      roles: ['SU', 'GH', 'TM'],
      id: 'emails', link: '/emails', image: 'assets/img/email.svg', class: '',
      icon: 'email',
      module: ['emails']
    },
    {
      name: 'Messages',
      roles: ['TM', 'GH', 'SU', 'AAM'],
      id: 'messages', link: '/messages', image: 'assets/img/messages.svg', class: '',
      icon: 'chat',
      module: ['messages']
    },
    {
      name: 'Notifications',
      roles: ['TM', 'GH', 'SU', 'AAM'],
      id: 'notifications', link: '/notifications', image: 'assets/img/notification.svg', class: '',
      icon: 'notifications',
      module: ['notifications']
    },
    {
      name: 'Audit Trails',
      roles: ['GH', 'SU', 'AAM'],
      id: 'audit trails', link: '/audit', image: 'assets/img/audits.svg', class: '',
      icon: 'history',
      module: ['audit']
    },
    {
      name: 'Groups',
      roles: ['AAM', 'SU'],
      id: 'groups', link: '/groups', image: 'assets/img/total.svg', class: '',
      icon: 'groups',
      module: ['groups']
    },
  ]

  navConnect = [
    {
      name: 'Firm Profile',
      roles: ['AAM'],
      id: 'firm profile', link: '/profile', image: 'assets/img/Firmprofile.svg', class: '',
      icon: 'person',
      module: ['profile']
    },
    {
      name: 'Documents',
      roles: ['TM', 'GH', 'SU'],
      id: 'documents', link: '/documents', image: 'assets/img/Document.svg', class: '',
      icon: 'description',
      module: ['documents']
    },
    {
      name: 'Relationships',
      roles: ['TM', 'GH', 'SU'],
      id: 'relationships', link: '/relationship/view/business', image: 'assets/img/relationship.svg', class: '',
      icon: 'people',
      module: ['relationship']
    },
    {
      name: 'Meetings',
      roles: ['TM', 'GH', 'SU', 'AAM'],
      id: 'meetings', link: '/meetings/create', image: 'assets/img/meeting.svg', class: '',
      icon: 'event_note',
      module: ['meetings']
    },
    {
      name: 'Messages',
      roles: ['TM', 'GH', 'SU', 'AAM'],
      id: 'messages', link: '/messages', image: 'assets/img/messages.svg', class: '',
      icon: 'chat',
      module: ['messages']
    },
    // {
    //   name: 'Notes',
    //   roles: ['TM', 'GH', 'SU'],
    //   id: 'notes', link: '/notes', image: 'assets/img/notes.svg', class: '',
    //   icon: 'note',
    //   module: ['notes']
    // },
    {
      name: 'Notifications',
      roles: ['TM', 'GH', 'SU', 'AAM'],
      id: 'notifications', link: '/notifications', image: 'assets/img/notification.svg', class: '',
      icon: 'notifications',
      module: ['notifications']
    },
    {
      name: 'Audit Trails',
      roles: ['GH', 'SU', 'AAM'],
      id: 'audit trails', link: '/audit', image: 'assets/img/audits.svg', class: '',
      icon: 'history',
      module: ['audit']
    },
    {
      name: 'Groups',
      roles: ['AAM', 'SU'],
      id: 'groups', link: '/groups/view-group', image: 'assets/img/total.svg', class: '',
      icon: 'groups',
      module: ['groups']
    }
  ]

  userRole: string = '';
  termAccept: any;
  loadTerms: any;
  showTermsModal: boolean = false;
  isChecked: boolean = false;
  termsUrl: string = '';
  termsVersion: string = '';
  safeTermsUrl: any;

  constructor(public router: Router, private sanitizer: DomSanitizer, private httpService: HttpService, private route: ActivatedRoute,  private xmppService: XmppService,
    private httpClient: HttpClient, private cdr: ChangeDetectorRef,
    private sessionService: SessionService, private sidebarService: SidebarService) {

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        //console.log("windowLoc", window.location.pathname.split("/").splice(-4)[1]);
        //this.getCategory(window.location.pathname.split("/").splice(-4)[1]);
      }
    });

    // this.httpService.items.subscribe((newItem: any) => {
    //   this.getCategory(newItem);
    // });
  }

  ngOnInit() {
    this.product = (localStorage.getItem('product') || 'lauditor').trim().toLowerCase();
    this.userRole = (localStorage.getItem('role') || '').trim().toUpperCase();
    this.category = localStorage.getItem('category') || '';
    this.isSoloCategory = this.category === 'solo';
    this.originalNavItems = [...this.navItem];
    this.filterNavItems(); // First modify nav items
    this.setActiveNavItems(); // Then apply role filtering
    // console.log('navItem after filter =>', this.navItem);
    // console.log('activeNavItems =>', this.activeNavItems);
    this.termAccept = localStorage.getItem('requiresTermsAcceptance')
    //console.log('this.term',this.termAccept)

    if (this.termAccept === 'true') {
      this.openTermsDialog();
    }

    this.httpService.unreadCount$.subscribe(count => {
      this.notificationCount = count;
    });  // notify count updates
    this.getUnreadCountFromAPI(); // load initial notify count

    // assign interval id so it can be cleared later
    this.notificationIntervalId = setInterval(() => this.getUnreadCount(), 60000); // 60s recommended
    this.getUnreadCount();  // immediately fetch once

    // localStorage.setItem('plan', this.plan); // Update localStorage
    // console.log('Dashboard initialized');

    this.httpService.name$.subscribe(name => {
      if (name) this.name = name;
    });

    this.httpService.firmName$.subscribe(firmName => {
      if (firmName) this.firmName = firmName;
    });

    this.httpService.profilePic$.subscribe(url => {
      this.profilePic = url;
      // console.log('Profile pic updated via subscription:', url);
    });
    // console.log('Dashboard initialized - fetching profile pic');
    this.getData(); //get profile
    this.category = localStorage.getItem('category') || '';
    this.isSoloCategory = this.category === 'solo';
    this.originalNavItems = [...this.navItem]; // Keep a copy of original items
    //this.filterNavItems();
    this.route.queryParams.subscribe(params => {
      this.key = params['key'];
      if (params['key']) {
        //console.log(params['key'])
        const jsonString = this.key?.replace(/^data=/, '');
        const jsonObject = JSON.parse(jsonString);
        //console.log(jsonObject)
        this.getSOSlogin(jsonObject)
        this.initalize_roles()
      }
    });

    // this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //     // Close mobile/tablet drawer on every navigation
    //     this.isMobileMenuOpen = false;

    //     const urlPath = this.router.url.split('?')[0]; // strip query params
    //     const fullUrl = this.router.url; // full URL including query params

    //     // ── STEP 1: Try to get title from our comprehensive route-to-title mapping ──
    //     const mappedTitle = this.getPageTitleFromRoute(urlPath, fullUrl);

    //     if (mappedTitle) {
    //       this.categoryName = mappedTitle;
    //       this.updateActiveItemFromRoute(urlPath, fullUrl);
    //       localStorage.setItem('categoryName', this.categoryName);
    //       return;
    //     }

    //     // ── STEP 2: Fall back to original nav item matching logic ──
    //     const urlSegments = urlPath.split('/').filter(s => s);
    //     const firstSegment = urlSegments[0];

    //     if (firstSegment === 'grid') {
    //       this.categoryName = 'Dashboard';
    //       this.selectedItem = 'grid';
    //       this.activeItemId = 'grid';
    //       localStorage.setItem('categoryName', this.categoryName);
    //       localStorage.setItem('activeNavItem', 'grid');
    //       return;
    //     }

    //     // 1. Try to match a top-level nav item (across ALL product nav arrays)
    //     const allNavArrays = [this.navItem, this.navCorporate, this.navContent, this.navConnect];
    //     let matchedItem: any = null;
    //     let matchedChild: any = null;

    //     for (const navArray of allNavArrays) {
    //       for (const item of navArray) {
    //         // Check if firstSegment matches a module on the top-level item
    //         if (item.module && item.module.includes(firstSegment)) {
    //           matchedItem = item;
    //           // Check if a child route matches the full URL path
    //           if ('children' in item && item.children) {
    //             const childMatch = (item.children as any[]).find((c: any) =>
    //               urlPath.startsWith(c.route)
    //             );
    //             if (childMatch) {
    //               matchedChild = childMatch;
    //             }
    //           }
    //           break;
    //         }
    //       }
    //       if (matchedItem) break;
    //     }

    //     if (matchedItem) {
    //       if (matchedChild) {
    //         // Show the child label as the header title (e.g. 'Legal matters')
    //         this.categoryName = matchedChild.label;
    //         this.selectedItem = matchedChild.activeId;
    //         this.activeItemId = matchedChild.activeId;
    //         // Expand the parent submenu so it is visually open
    //         this.expandedItem = matchedItem.name;
    //         localStorage.setItem('categoryName', matchedChild.label);
    //         localStorage.setItem('activeNavItem', matchedChild.activeId);
    //       } else {
    //         this.categoryName = matchedItem.name;
    //         this.selectedItem = matchedItem.id;
    //         this.activeItemId = matchedItem.id;
    //         this.expandedItem = null;
    //         localStorage.setItem('categoryName', matchedItem.name);
    //         localStorage.setItem('activeNavItem', matchedItem.id);
    //       }
    //     } else {
    //       this.selectedItem = null;
    //     }
    //   }
    // });



    // Restore sidebar collapsed state from localStorage
    
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isMobileMenuOpen = false;

        const urlPath = this.router.url.split('?')[0];
        const fullUrl = this.router.url;

        // Single source of truth for sidebar highlighting — runs on every
        // navigation regardless of whether we have a title mapping.
        this.updateActiveItemFromRoute(urlPath, fullUrl);

        // STEP 1: title from the explicit mapping
        const mappedTitle = this.getPageTitleFromRoute(urlPath, fullUrl);
        if (mappedTitle) {
          this.categoryName = mappedTitle;
          localStorage.setItem('categoryName', this.categoryName);
          return;
        }

        // STEP 2: fallback — title only, activeItemId is already correct above
        const urlSegments = urlPath.split('/').filter(s => s);
        const firstSegment = urlSegments[0];

        if (firstSegment === 'grid') {
          this.categoryName = 'Dashboard';
          localStorage.setItem('categoryName', this.categoryName);
          return;
        }

        const allNavArrays = [this.navItem, this.navCorporate, this.navContent, this.navConnect];
        let matchedItem: any = null;
        let matchedChild: any = null;

        for (const navArray of allNavArrays) {
          for (const item of navArray) {
            if (item.module && item.module.includes(firstSegment)) {
              matchedItem = item;
              if ('children' in item && item.children) {
                matchedChild = (item.children as any[]).find((c: any) => urlPath.startsWith(c.route));
              }
              break;
            }
          }
          if (matchedItem) break;
        }

        if (matchedItem) {
          this.categoryName = matchedChild ? matchedChild.label : matchedItem.name;
          localStorage.setItem('categoryName', this.categoryName);
        }
      }
    });

    const savedCollapsed = localStorage.getItem('sidebarCollapsed');
    if (savedCollapsed !== null) {
      this.isSidebarCollapsed = JSON.parse(savedCollapsed);
    }

    // Feature routes (e.g. the document editor) can request a focused, sidebar-
    // collapsed view. We honour it without persisting, so the user's saved
    // preference is untouched and 'restore' reverts to exactly what they chose.
    this.sidebarRequestSub = this.sidebarService.request$.subscribe((req) => {
      if (req === 'collapse') {
        this.isSidebarCollapsed = true;
        this.expandedItem = null;
      } else {
        const saved = localStorage.getItem('sidebarCollapsed');
        this.isSidebarCollapsed = saved !== null ? JSON.parse(saved) : false;
      }
      this.cdr.detectChanges();
    });

    // If landing on /grid (post-login dashboard), always reset title and active item
    // regardless of what localStorage may have left over from a previous session.
    const currentUrlPath = this.router.url.split('?')[0];
    const isGridPage = currentUrlPath === '/grid' || currentUrlPath === '/' || currentUrlPath === '';

    if (isGridPage) {
      // Authoritative reset — previous session's stale values must not bleed through
      this.categoryName = 'Dashboard';
      this.activeItemId = 'grid';
      this.expandedItem = null;
      localStorage.setItem('categoryName', 'Dashboard');
      localStorage.setItem('activeNavItem', 'grid');
    } else {
      // Non-grid page: safe to restore last known title
      const storedCategoryName = localStorage.getItem('categoryName');
      if (storedCategoryName) {
        this.categoryName = storedCategoryName;
      }
      this.activeItemId = localStorage.getItem('activeNavItem');
    }

    this.initalize_roles()
    //window.location.pathname == '/grid'

    this.updateTime();
    this.groups = JSON.parse(localStorage.getItem('user_groups') || '[]').join(' | ');
    this.AAM_email = localStorage.getItem("AAM_email") || "";
    //this.useremail = localStorage.getItem("user_email") || "";
    const raw = localStorage.getItem("user_email") || "";
    try {
      this.useremail = JSON.parse(raw);
    } catch {
      this.useremail = raw;
    }
    this.firmName = localStorage.getItem("firm_name") || "";
    this.currentFirmId = localStorage.getItem("user_id") || "";


    // Load available firms AFTER localStorage is ready
    // setTimeout(() => {
    //   this.loadAvailableFirms();
    // }, 100);
    // const firms = localStorage.getItem('firms');

    // if (firms) {
    //   this.availableFirms = JSON.parse(firms);
    //   this.hasMultipleFirms = this.availableFirms.length > 1;
    // }
   
    const firms = localStorage.getItem('user_firms') || localStorage.getItem('firms');

    if (firms) {
      const parsedFirms = JSON.parse(firms);
      const currentFirmId = localStorage.getItem('user_id');

      this.availableFirms = parsedFirms.filter((firm: any) => {
        return firm.id !== currentFirmId;
      });

      this.hasMultipleFirms = this.availableFirms.length > 0;
    }
    // console.log('user_firms', localStorage.getItem('user_firms'));
    // console.log('availableFirms', this.availableFirms);


    //this.useremail = JSON.parse(localStorage.getItem('user_email') || '[]');
    //this.useremail = localStorage.getItem('user_email') || '';
    this.AAM_email = (localStorage.getItem('AAM_email') || '').replace(/"/g, '');
    //console.log('useremail',this.useremail)
    //console.log('groups', this.groups);

    this.httpService.sendGetRequest(URLUtils.profile).subscribe(
      (res: any) => {
        this.profile = res.data?.details;
      }
    )
    // this.getUnreadCount();
    // setInterval(() => this.getUnreadCount(), 60000); // refresh every 60s




    // subscribe to router events and keep reference for later unsubscribe
    this.routerSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        //...
      }
    });

  }

  openTermsDialog() {
    this.showTermsModal = true;

    this.httpService.sendGetRequest(URLUtils.termAccept).subscribe((res: any) => {
      this.loadTerms = res.data;
      this.termsUrl = res.data?.url;
      this.termsVersion = res.data?.version;

      if (this.termsUrl) {
        this.safeTermsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.termsUrl);
        // this.safeTermsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        //   'https://docs.google.com/gview?url=' + this.termsUrl + '&embedded=true'
        // );

        setTimeout(() => {
          this.cdr.detectChanges();
        });
      }
    });
    
  }


  agreeTerms() {
    if (!this.isChecked) return;

    this.httpService.sendPostRequest(URLUtils.agreeTermAccept, {
      version: this.termsVersion
    }).subscribe({
      next: (res: any) => {
        this.showTermsModal = false;

        // Optional: update localStorage
        localStorage.setItem('requiresTermsAcceptance', 'false');
        //localStorage.removeItem('requiresTermsAcceptance');
      }
    });
  }

  cancelTerms() {
    this.router.navigate(['/login']);
  }

  setActiveNavItems(): void {
    let navList: any[] = [];

    switch (this.product) {
      case 'corporate':
        navList = this.navCorporate;
        break;

      case 'content':
        navList = this.navContent;
        break;

      case 'connect':
        navList = this.navConnect;
        break;

      default:
        navList = this.navItem;
        break;
    }

    this.activeNavItems = navList.filter(item =>
      !item.roles || item.roles.includes(this.userRole)
    );

    // console.log('product =>', this.product);
    // console.log('role =>', this.userRole);
    // console.log('filtered nav =>', this.activeNavItems);
  }

  filterNavItems() {
    const category = (localStorage.getItem('category') || '').trim().toLowerCase();
    const role = (localStorage.getItem('role') || '').trim().toUpperCase();

    let filteredItems = [...this.originalNavItems];
    
    // AAM-specific changes
    if (role === 'AAM') {
      filteredItems = filteredItems
        .filter((item: any) => item.id !== 'matters')
        .map((item: any) => {
          
          if (item.id === 'messages' && item.children) {
            return {
              ...item,
              children: item.children.filter(
                (child: any) => child.activeId !== 'msg-clients'
              )
            };
          }

          return item;
        });
    }

    // Solo-specific changes
    if (category === 'solo') {
      const hideModules = ['members', 'groups'];

      filteredItems = filteredItems
        .filter((item: any) => !hideModules.includes(item.id))
        .map((item: any) => {
          if (item.id === 'profile') {
            const { children, ...rest } = item;
            return { ...rest, link: '/profile' };
          }


          if (item.id === 'timesheets') {
            return {
              ...item,
              name: 'Timesheets',
              id: 'timesheets',
              link: '/timesheets/non-submitted',
              children: [
                {
                  label: 'Not Submitted',
                  route: '/timesheets/non-submitted',
                  activeId: 'non-submitted'
                },
                {
                  label: 'Submitted',
                  route: '/timesheets/submitted',
                  activeId: 'submitted'
                },
              ]
            };
          }

          if (item.id === 'documents' && item.children) {
            return {
              ...item,
              children: item.children.filter(
                (child: any) => child.activeId !== 'doc-firm'
              )
            };
          }
           
          // if (item.id === 'relationships' && item.children) {
          //   return {
          //     ...item,
          //     children: item.children.filter(
          //       (child: any) => child.activeId !== 'deleted'
          //     )
          //   };
          // }

          if (item.id === 'messages' && item.children) {
            return {
              ...item,
              children: item.children.filter(
                (child: any) => child.activeId !== 'msg-teams'
              )
            };
          }

          return item;
        });
    }
    // Non-solo profile changes
    if (category !== 'solo') {
      filteredItems = filteredItems.map((item: any) => {
        if (item.id === 'profile') {
          // AAM, TM, GH: show simple "Profile" link without children
          if (role === 'AAM' || role === 'TM' || role === 'GH') {
            const { children, ...rest } = item;
            return {
              ...rest,
              name: 'My Profile',
              id: 'profile',
              link: '/profile'
            };
          }
          // SU: show "Profile" in sidebar (with children: Firm Profile, My Profile, Practice Partner)
          return {
            ...item,
            name: 'Profile',
            id: 'firm-profile',
            link: '/profile',
            children: [
              {
                label: 'Firm Profile',
                route: '/profile',
                category: 'Firm Profile',
                activeId: 'firm-profile',
                profileType: 'firm'
              },
              {
                label: 'My Profile',
                route: '/profile',
                category: 'My Profile',
                activeId: 'my-profile',
                profileType: 'personal'
              },
              {
                label: 'Practice Partner',
                route: '/partner',
                category: 'Practice Partner',
                activeId: 'partner'
              }
            ]
          };
        }

        if (item.id === 'messages' && role !== 'AAM') {
          return {
            ...item,
            name: 'Messages',
            id: 'messages',
            link: '/messages/clients',
            children: [
              {
                label: 'Clients',
                route: '/messages/clients',
                category: 'Messages - Clients',
                activeId: 'msg-clients'
              },
              {
                label: 'Teams',
                route: '/messages/teams',
                category: 'Messages - Teams',
                activeId: 'msg-teams'
              }
            ]
          };
        }

        if (item.id === 'messages' && role === 'AAM') {
          return {
            ...item,
            name: 'Messages',
            id: 'messages',
            link: '/messages/teams',
            route: '/messages/teams',
          };
        }

        if (item.id === 'timesheets') {
          const timesheetChildren = [
            {
              label: 'Aggregated Timesheet',
              category: 'AggregatedTimesheet',
              activeId: 'aggregate',
              route: '/timesheets/aggregate-projects',
              children: [
                {
                  label: 'Projects',
                  route: '/timesheets/aggregate-projects',
                  activeId: 'aggregate-projects'
                },
                {
                  label: 'Team Member',
                  route: '/timesheets/aggregate-members',
                  activeId: 'aggregate-members'
                }
              ]
            },
            {
              label: 'My Timesheet',
              category: 'MyTimesheet',
              activeId: 'my-timesheet',
              route: '/timesheets/non-submitted',
              children: [
                {
                  label: 'Not Submitted',
                  route: '/timesheets/non-submitted',
                  activeId: 'non-submitted'
                },
                {
                  label: 'Submitted',
                  route: '/timesheets/submitted',
                  activeId: 'submitted'
                }
              ]
            }
          ];

          return {
            ...item,
            name: 'Timesheets',
            id: 'timesheets',
            link: '/timesheets/non-submitted',
            children: role === 'TM'
              ? timesheetChildren.filter(child => child.activeId !== 'aggregate')
              : timesheetChildren
          };
        }

        if (item.id === 'relationships' && (role === 'GH' || role === 'TM') && item.children) {
          return {
            ...item,
            children: item.children.filter(
              (child: any) => child.activeId !== 'deleted'
            )
          };
        }
              
        if (item.id === 'documents' && role !== 'SU' && item.children) {
            return {
              ...item,
              children: item.children.filter(
                (child: any) => child.activeId !== 'doc-delete'
              )
            };
        }
                
        // if (item.id === 'documents' && item.children) {
        //   return {
        //     ...item,
        //     children: item.children.filter((child: any) => {
        //       if (child.activeId === 'doc-firm') return false;           // always remove
        //       if (child.activeId === 'doc-delete' && role !== 'SU') return false; // remove if not SU
        //       return true;
        //     })
        //   };
        // }

        return item;
      });
    }
    else {
      // filteredItems = filteredItems.map((item: any) => {
      //   if (item.id === 'timesheets') {
      //     return {
      //       ...item,
      //       name: 'Timesheets',
      //       id: 'timesheets',
      //       link: '/timesheets/non-submitted',
      //       children: [
      //         {
      //           label: 'Submitted',
      //           route: '/timesheets/submitted',
      //           activeId: 'submitted'
      //         },
      //         {
      //           label: 'Non-Submitted',
      //           route: '/timesheets/non-submitted',
      //           activeId: 'non-submitted'
      //         }
      //       ]
      //     };
      //   }
      //   return item;
      // });
    }

    this.navItem = filteredItems;

    // console.log('category =>', category);
    // console.log('role =>', role);
    // console.log('filtered nav =>', this.navItem);
  }

  toggleNestedSubmenu(label: string): void {
    this.expandedNestedItem = this.expandedNestedItem === label ? null : label;
  }
  
  isNestedChildActive(children: any[]): boolean {
    return children?.some((sub: any) => this.router.url === sub.route);
  }

  openSupport() {
    const to = 'support@lexiz.ai';
    const subject = encodeURIComponent('Support Request');
    const body = encodeURIComponent(
      'Hi Support Team,\n\nI need help with...\n\nThanks'
    );

    // 1️⃣ Gmail Web (most reliable across all platforms)
    const gmailUrl =
      `https://mail.google.com/mail/?view=cm&fs=1` +
      `&to=${to}&su=${subject}&body=${body}`;

    const newTab = window.open(gmailUrl, '_blank');

    // 2️⃣ If popup blocked → fallback to mailto
    if (!newTab) {
      try {
        window.location.href = `mailto:${to}?subject=${subject}&body=${body}`;
      } catch {
        this.copySupportEmail(to);
      }
    }
  }

  copySupportEmail(email: string) {
    navigator.clipboard.writeText(email).then(() => {
      alert(`Please email us at ${email}`);
    });
  }


  getData() {
    // AAM's topbar avatar is the firm logo, not a personal profile pic.
    // Use the firm logo endpoint for AAM; personal pic endpoint for all other roles.
    if (this.userRole === 'AAM') {
      this.httpService.sendGetRequest(URLUtils.firmlogo).subscribe((res: any) => {
        const imageUrl = res?.data?.url || res?.data?.imageUrl || res?.imageUrl || null;
        this.profilePic = imageUrl;
        this.httpService.setProfilePic(imageUrl);
      });
    } else {
      this.httpService.sendGetRequest(URLUtils.profilePic).subscribe((img: any) => {
        const imageUrl = img?.data?.imageUrl || null;
        this.profilePic = imageUrl;
        this.httpService.setProfilePic(imageUrl); // sync everywhere
      });
    }
  }

  loadAvailableFirms() {
    try {
      const raw = localStorage.getItem('user_firms') || localStorage.getItem('firms');
      // console.log('=== LOADING AVAILABLE FIRMS ===');
      // console.log('Raw firms data:', raw);

      if (!raw || raw === 'undefined' || raw === 'null') {
        //console.warn('No firms found in localStorage');
        this.availableFirms = [];
        this.hasMultipleFirms = false;
        return;
      }

      const allFirms = JSON.parse(raw);
      //console.log('Parsed firms:', allFirms);

      if (!Array.isArray(allFirms)) {
        //console.error('Firms data is not an array');
        this.availableFirms = [];
        this.hasMultipleFirms = false;
        return;
      }

      // Get current firm ID from localStorage
      const currentFirmId = localStorage.getItem("user_id");
      //console.log('Current firm ID:', currentFirmId);

      // Filter out current firm and map to display format
      this.availableFirms = allFirms
        .filter((firm: any) => {
          //console.log('Checking firm:', firm.id, 'against current:', currentFirmId);
          return firm.id !== currentFirmId;
        })
        .map((firm: any) => ({
          id: firm.id,
          firmName: firm.firmName || firm.name || 'Unknown Firm',
          name: firm.firmName || firm.name || 'Unknown Firm'
        }));

      //console.log('Available firms to switch:', this.availableFirms);
      this.hasMultipleFirms = this.availableFirms.length > 0;

      // Force change detection
      this.cdr.detectChanges();
    } catch (error) {
      //console.error('Error loading available firms:', error);
      this.availableFirms = [];
      this.hasMultipleFirms = false;
    }
  }



  normalizePath(path: string): string {
    // Remove trailing 's' if it exists
    return path.endsWith('s') ? path.slice(0, -1) : path;
  }

  ngAfterViewInit(): void {
    //   const popoverTrigger = document.querySelector('.username') as HTMLElement;
    //   new bootstrap.Popover(popoverTrigger, {
    //     container: 'body',
    //     trigger: 'hover',
    //     html: true, // Allows HTML content in the popover
    //   });
  }

  initalize_roles() {
    var name = localStorage.getItem("name")
    if (name != null) { this.name = name }
    var role = localStorage.getItem("role")
    if (role != null) { this.roleId = role }
    if (role == 'SU') { this.role = 'SuperUser' }
    if (role == 'AAM') { this.role = 'Admin' }
    if (role == 'TM') { this.role = 'Team Member' }
    if (role == 'GH' && this.product == 'corporate') { this.role = 'Department Head' }
    if (role == 'GH' && this.product != 'corporate') { this.role = 'Group Head' }
  }

  getCategory(category: string): void {
    // console.log("GetcategoryName", category);
    // console.log('this.categoryName',this.categoryName)
    window.scrollTo(0, 0);
    //this.categoryName = category; // restricting sub and nonsub entries
    
    this.selectedItem = category; // Set the selected item
    //console.log('selectedItem', this.selectedItem);

    // NOTE: activeNavItem is set authoritatively by the NavigationEnd router subscription.
    // Writing it here with a display-label would break isActive() checks, so we only
    // persist the human-readable title for UI restoration on reload.
    localStorage.setItem('categoryName', this.categoryName);
  }


  isActive(itemId: string): boolean {
    // Prefer the in-memory value (kept in sync by NavigationEnd subscription);
    // fall back to localStorage for the first render before any navigation fires.
    const active = this.activeItemId ?? localStorage.getItem('activeNavItem');
    // console.log('isActive check:', itemId);
    // console.log('activeItemId:', this.activeItemId);

    // Don't highlight any sidebar menu when on dashboard (grid page)
    if (active === 'grid' || active === 'dashboard') {
      return false;
    }

    return active === itemId;
  }

  /** Returns true when the item itself OR any of its submenu children is the active page. */
  // isParentActive(item: any): boolean {
  //   if (this.isActive(item.id)) { return true; }
  //   if ('children' in item && item.children) {
  //     return (item.children as any[]).some((c: any) => this.isActive(c.activeId));
  //   }
  //   return false;
  // }

  // isParentActive(item: any): boolean {

  //   if (!item.children) return false;

  //   for (let child of item.children) {

  //     // first level — use startsWith so query params (e.g. ?profileType=personal) don't break the match
  //     if (child.route && this.router.url.split('?')[0] === child.route) {
  //       return true;
  //     }

  //     // second level
  //     if (child.children) {
  //       for (let sub of child.children) {
  //         if (this.router.url.split('?')[0] === sub.route) {
  //           return true;
  //         }
  //       }
  //     }

  //   }

  //   return false;
  // }
  isParentActive(item: any): boolean {
    if (!item.children) return false;

    for (let child of item.children) {
      // Primary check: same source of truth the child links already use.
      // This is what makes it work for add/edit/create routes, not just view routes.
      if (child.activeId && this.isActive(child.activeId)) {
        return true;
      }

      // Fallback: exact route match for anything not covered by activeId.
      if (child.route && this.router.url.split('?')[0] === child.route) {
        return true;
      }

      if (child.children) {
        for (let sub of child.children) {
          if (sub.activeId && this.isActive(sub.activeId)) {
            return true;
          }
          if (this.router.url.split('?')[0] === sub.route) {
            return true;
          }
        }
      }
    }

    return false;
  }

  setActiveNavItem(category: string) {
    //console.log("settoGetcategoryName", this.categoryName);
    const categoryList = document.getElementsByClassName('left-menu-icon');
    for (let i = 0; i < categoryList.length; i++) {
      if (categoryList[i].classList.contains(category)) {
        categoryList[i].classList.add('active');
      } else {
        categoryList[i].classList.remove('active');
      }
    }
  }

  ngOnChanges() {
    // this.httpService.items.subscribe((newItem: any) => {
    //   this.getCategory(newItem);
    // });
  }

  // logout() {
  //   // localStorage.removeItem('validationDone')
  //   // localStorage.removeItem('TOKEN')
  //   // localStorage.removeItem('popupOpened')
  //   // localStorage.removeItem('name')
  //   // localStorage.removeItem('role')
  //   this.router.navigate(['/'])
  //   localStorage.clear();
  //   sessionStorage.clear();
  //   window.location.reload();
  // }
  // ──────────────────────────────────────────────────────────────────────────
  // ROUTE-TO-TITLE MAPPING HELPERS
  // ──────────────────────────────────────────────────────────────────────────

  /**
   * Gets the page title based on the current route.
   * Handles both exact matches and dynamic routes with parameters (e.g., /edit/:id)
   */
  private getPageTitleFromRoute(urlPath: string, fullUrl?: string): string | null {
    // Remove trailing slash for consistent matching
    const normalizedPath = urlPath.endsWith('/') && urlPath.length > 1
      ? urlPath.slice(0, -1)
      : urlPath;

    // ── Profile sub-page resolution (uses query param profileType) ──
    if (normalizedPath === '/profile' && fullUrl) {
      if (fullUrl.includes('profileType=personal')) { return 'My Profile'; }
      // 'profileType=firm' or no profileType → Firm Profile only for SU (non-solo, non-AAM, non-TM, non-GH)
      if (!this.isSoloCategory && this.roleId !== 'AAM' && this.roleId !== 'TM' && this.roleId !== 'GH') { return 'Firm Profile'; }
    }

    // ── Exact route matches ──
    const exactMatches: Record<string, string> = {
      // Dashboard
      '/grid': 'Dashboard',

      // Profile
      '/profile': this.roleId === 'AAM' ? 'Firm Profile' : 'My Profile',
      '/partner': 'Practice Partner',

      // Appointments
      '/appointments': 'Appointments',

      // Matters - View routes
      '/matter/legalmatter/view': 'Legal Matters',
      '/legalmatter/view': 'Legal Matters',
      '/matter/legalmatter/view/external': 'External Legal Matters',
      '/matter/legalmatter/external': 'External Legal Matters',
      '/matter/generalmatter/view': 'General Matters',
      '/generalmatter/view': 'General Matters',
      '/matter/generalmatter/view/external': 'External General Matters',
      '/internal': 'Internal Matters',

      // Matters - Details routes
      '/legalmatter/viewDetails': 'Legal Matter Details',
      '/legalmatter/externalviewDetails': 'External Legal Matter Details',
      '/generalmatter/viewDetails': 'General Matter Details',
      '/generalmatter/generalinternalviewdetails': 'General Matter Details',

      // Matters - Create routes (UPDATED FOR SPECIFICITY)
      '/legalmatter/create': 'Create Legal Matter',
      '/matter/legalmatter/create': 'Create Legal Matter',
      '/generalmatter/create': 'Create General Matter',
      '/matter/generalmatter/create': 'Create General Matter',

      // Matters - Update routes
      '/legalmatter/updateGroups': 'Update Legal Matter Groups',
      '/legalmatter/updateTeams': 'Update Legal Matter Teams',
      '/generalmatter/updateGroups': 'Update General Matter Groups',
      '/generalmatter/updateTeams': 'Update General Matter Teams',

      // Matters - Other routes
      '/matterClients': 'Matter Clients',
      '/MatterDocuments': 'Matter Documents',
      '/MatterGroups': 'Matter Groups',
      '/MatterTeamMembers': 'Matter Team Members',

      // Documents
      '/documents': 'Documents',
      '/documents/view/matter': 'Matter Documents',
      '/documents/view/client': 'Client Documents',
      '/documents/view/firm': 'Firm Documents',
      '/documents/view/delete': 'Deleted Documents',
      '/documents/view/general': 'General Documents',
      '/documents/view/relationship': 'Relationship Documents',
      '/documents/view/meeting': 'Meeting Documents',
      '/documents/upload/matter': 'Upload Matter Document',
      '/documents/upload/general': 'Upload General Document',
      '/documents/upload/relationship': 'Upload Relationship Document',
      '/documents/upload/meeting': 'Upload Meeting Document',
      '/documents/mergepdf/matter': 'Merge PDF - Matter',
      '/documents/mergepdf/general': 'Merge PDF - General',
      '/documents/mergepdf/relationship': 'Merge PDF - Relationship',
      '/documents/mergepdf/meeting': 'Merge PDF - Meeting',

      // Merge PDF
      '/mergepdf': 'Merge PDF',

      // Doc Editor
      '/doceditor': 'Document Editor',

      // Relationships - View routes (UPDATED FOR SPECIFICITY)
      '/relationship/view': 'Relationships',
      '/relationship/view/individuals': 'Individual Relationships',
      '/relationship/view/business': 'Business Relationships',
      '/relationship/view/corporate': 'Corporate Relationships',
      '/relationship/view/deleted': 'Deleted Relationships',

      // Relationships - Add routes (UPDATED FOR SPECIFICITY)
      '/relationship/add': 'Add Relationship',
      '/relationship/add/individual': 'Add Individual Relationship',
      '/relationship/add/entity': 'Add Business Relationship',
      '/relationship/add/corporate': 'Add Corporate Relationship',

      // Timesheets
      '/timesheets/aggregate-members': 'Aggregated Timesheet',
      '/timesheets/aggregate-projects': 'Aggregated Projects',
      '/timesheets/non-submitted': 'Timesheet Entry',
      '/timesheets/submitted': 'Timesheet Entry',

      // Meetings
      '/meetings': 'Meetings',
      '/meetings/view': 'Meetings',
      '/meetings/create': 'Create Meeting',
      '/meetings/edit': 'Edit Meeting',
      '/view/event': 'Meeting Details',

      // Emails
      '/emails': 'Emails',

      // Messages
      '/messages': 'Messages',
      '/messages/clients': 'Messages',
      '/messages/teams': 'Messages',

      // Notes
      '/notes': 'Notes',

      // Notifications
      '/notifications': 'Notifications',

      // Audit Trails
      '/audit': 'Audit Trails',

      // Groups & Members
      '/groups/view-group': 'Groups',
      '/groups/create-group': 'Create Group',
      '/groups/view-member': 'Members',
      '/groups/create-member': 'Create Member',
      //'/groups': 'Groups',

      // Invoices
      '/invoice': 'Invoices',

      // Payments
      '/payment': 'Payments',
    };

    // Check for exact match first
    if (exactMatches[normalizedPath]) {
      return exactMatches[normalizedPath];
    }

    // ── Dynamic route patterns (with parameters) ──
    // Check if path matches patterns like /edit/:id, /view/:filter/:id, etc.

    // Legal Matter Edit (with ID parameter)
    if (normalizedPath.startsWith('/legalmatter/edit/') ||
      normalizedPath.startsWith('/matter/legalmatter/edit/')) {
      return 'Edit Legal Matter';
    }

    // General Matter Edit (with ID parameter)
    if (normalizedPath.startsWith('/generalmatter/edit/') ||
      normalizedPath.startsWith('/matter/generalmatter/edit/')) {
      return 'Edit General Matter';
    }

    // Relationship view with filters and highlight parameter
    if (normalizedPath.match(/^\/relationship\/view\/[^/]+\/[^/]+$/)) {
      // Extract the filter type from the path
      const parts = normalizedPath.split('/');
      const filterType = parts[3]; // e.g., 'individuals', 'business', 'corporate'

      if (filterType === 'individuals') {
        return 'Individual Relationship Details';
      } else if (filterType === 'business') {
        return 'Business Relationship Details';
      } else if (filterType === 'corporate') {
        return 'Corporate Relationship Details';
      } else if (filterType === 'deleted') {
        return 'Deleted Relationship Details';
      }
      return 'Relationship Details';
    }

    // Meeting edit
    if (normalizedPath.match(/^\/meetings\/edit/)) {
      return 'Edit Meeting';
    }

    // Calender/Meeting create with params
    if (normalizedPath.match(/^\/calender\/create/)) {
      return 'Create Meeting';
    }

    return null;
  }

  /**
   * Updates the activeItemId based on the current route
   */
  private updateActiveItemFromRoute(urlPath: string, fullUrl?: string): void {
    // Special handling for dashboard/grid - no sidebar item should be active
    if (urlPath === '/grid' || urlPath.includes('/grid')) {
      this.activeItemId = 'grid';
      this.expandedItem = null;
      localStorage.setItem('activeNavItem', 'grid');
      return;
    }

    // Determine which nav item should be active based on the route
    if (urlPath.includes('/legalmatter') || urlPath.includes('/matter/legalmatter')) {
      this.activeItemId = 'legalmatter';
      this.expandedItem = 'Matters';
    } else if (urlPath.includes('/generalmatter') || urlPath.includes('/matter/generalmatter')) {
      this.activeItemId = 'generalmatter';
      this.expandedItem = 'Matters';
    } else if (urlPath.includes('/documents')) {
      // Match specific document submenu children first
      if (urlPath.includes('/documents/view/matter') || urlPath.includes('/documents/upload/matter') || urlPath.includes('/documents/mergepdf/matter')) {
        this.activeItemId = 'doc-matter';
      } else if (urlPath.includes('/documents/view/client') || urlPath.includes('/documents/upload/client') || urlPath.includes('/documents/mergepdf/client')) {
        this.activeItemId = 'doc-client';
      } else if (urlPath.includes('/documents/view/firm') || urlPath.includes('/documents/upload/firm') || urlPath.includes('/documents/mergepdf/firm')) {
        this.activeItemId = 'doc-firm';
      } else if (urlPath.includes('/documents/view/delete')) {
        this.activeItemId = 'doc-delete';
      } else {
        this.activeItemId = 'documents';
      }
      this.expandedItem = 'Documents';
    } 
    else if (urlPath.includes('/subscribe')) {
      // if (this.activeItemId == 'my-profile' || this.activeItemId == 'firm-profile'){
      //    this.activeItemId == 'firm-profile';
      //    this.expandedItem = 'Profile';
      // }
      //else if(this.activeItemId == 'settings'){
        this.activeItemId = 'settings';
        this.expandedItem = 'Settings';
      //}
    } 
    else if (urlPath.includes('/relationship')) {
      // Check for specific relationship types
      if (urlPath.includes('/individuals') || urlPath.includes('/add/individual')) { //
        this.activeItemId = 'individuals';
        this.expandedItem = 'Relationships';
      }       
      else if (urlPath.includes('/business') || urlPath.includes('/add/business') || urlPath.includes('/add/entity')) {
        this.activeItemId = 'business';
        this.expandedItem = 'Relationships';
      } else if (urlPath.includes('/corporate') || urlPath.includes('/add/corporate')) {
        this.activeItemId = 'corporate';
        this.expandedItem = 'Relationships';
      } else if (urlPath.includes('/deleted')) {
        this.activeItemId = 'deleted';
        this.expandedItem = 'Relationships';
      } else if (urlPath.includes('/entity')) {
        // 'entity' maps to business in the add flow
        this.activeItemId = 'business';
        this.expandedItem = 'Relationships';
      } else {
        this.activeItemId = 'relationships';
        this.expandedItem = 'Relationships';
      }
    } else if (urlPath.includes('/timesheets')) {
      if (urlPath.includes('/aggregate')) {
        this.activeItemId = 'aggregate';
        this.expandedItem = 'Timesheets';
      } else if (urlPath.includes('/non-submitted')) {
        this.activeItemId = 'non-submitted';
        this.expandedItem = 'Timesheets';
      } else if (urlPath.includes('/submitted')) {
        this.activeItemId = 'submitted'; // Still highlight the same item
        this.expandedItem = 'Timesheets';
      }
    } else if (urlPath.includes('/meetings') || urlPath.includes('/calender')) {
      this.activeItemId = 'meetings';
      this.expandedItem = null;
    } else if (urlPath.includes('/appointments')) {
      this.activeItemId = 'appointments';
      this.expandedItem = null;
    } else if (urlPath.includes('/partner')) {
      this.activeItemId = 'partner';
      this.expandedItem = this.isSoloCategory ? null : 'Profile';
    } else if (urlPath.includes('/profile')) {
      if (fullUrl && fullUrl.includes('profileType=personal')) {
        this.activeItemId = 'my-profile';
      } else {
        this.activeItemId = 'firm-profile';
      }
      this.expandedItem = this.isSoloCategory ? null : 'Profile';
    } else if (urlPath.includes('/emails')) {
      this.activeItemId = 'emails';
      this.expandedItem = null;
    } else if (urlPath.includes('/messages')) {
      if (urlPath.includes('/messages/teams')) {
        this.activeItemId = 'msg-teams';
      } else {
        // /messages/clients and any other /messages/* default to clients
        this.activeItemId = 'msg-clients';
      }
      this.expandedItem = 'Messages';
    } else if (urlPath.includes('/notifications')) {
      this.activeItemId = 'notifications';
      this.expandedItem = null;
    } else if (urlPath.includes('/audit')) {
      this.activeItemId = 'audit trails';
      this.expandedItem = null;
    } else if (urlPath.includes('/groups/view-member') || urlPath.includes('/groups/create-member')) {
      this.activeItemId = 'members';
      this.expandedItem = null;
    } else if (urlPath.includes('/groups/view-group') || urlPath.includes('/groups/create-group')) {
      this.activeItemId = 'groups';
      this.expandedItem = null;
    } else if (urlPath.includes('/invoice')) {
      this.activeItemId = 'invoices';
      this.expandedItem = null;
    } else if (urlPath.includes('/payment')) {
      this.activeItemId = 'payments';
      this.expandedItem = null;
    }

    // Store in localStorage
    if (this.activeItemId) {
      localStorage.setItem('activeNavItem', this.activeItemId);
    }
  }

  logout() {
    if (this.notificationIntervalId) clearInterval(this.notificationIntervalId);
    if (this.timer) clearInterval(this.timer);
    if (this.routerSub) this.routerSub.unsubscribe();

    this.httpService.cancelPendingRequests(); //prevent triggers cancel
    // Explicitly reset nav state so the next session always starts at Dashboard
    this.httpService.logout()
    this.xmppService.disconnect();
    // this.sessionService.endSession();
    // localStorage.removeItem('categoryName');
    // localStorage.removeItem('activeNavItem');
    // localStorage.clear();
    // sessionStorage.clear();
    // window.location.href = '/login';

    // this.router.navigate(['/login']);
  }

  getSOSlogin(resp: any) {
    localStorage.setItem('TOKEN', resp.token);
    localStorage.setItem('name', resp.data.name);
    localStorage.setItem('role', resp.data.role);
    localStorage.setItem('plan', resp.data.plan);
    localStorage.setItem('isadmin', resp.data.admin);
    localStorage.setItem('jid', resp.data.uid);
    localStorage.setItem('firm_name', resp.data.firm_name);
    localStorage.setItem('category', resp.category);

    // Store firms array
    if (resp?.data?.firms && Array.isArray(resp.data.firms)) {
      localStorage.setItem('user_firms', JSON.stringify(resp.data.firms));
      //console.log('Stored firms:', resp.data.firms);
    } else {
      localStorage.removeItem('user_firms');
    }

    // Reload firms after login
    // setTimeout(() => {
    //   this.loadAvailableFirms();
    // }, 100);

  }



  ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.sidebarRequestSub?.unsubscribe();
  }

  toggleNotifications() {
    this.router.navigate(['/notifications']);
    // this.showNotifications = !this.showNotifications;
    // if (this.showNotifications) {
    //   this.getNotification();
    // }  
  }

  /** Formats a Date into "HH:MM AM/PM" for the header user-info block. */
  private formatTime(d: Date): string {
    const h = d.getHours();
    const m = d.getMinutes();
    const ap = h >= 12 ? 'PM' : 'AM';
    const h12 = h % 12 === 0 ? 12 : h % 12;
    return `${String(h12).padStart(2, '0')}:${String(m).padStart(2, '0')} ${ap}`;
  }

  updateTime() {
    // Set immediately so there is no blank flash on first render
    this.currentTime = this.formatTime(new Date());

    this.timer = setInterval(() => {
      this.time = new Date();
      this.ampm = this.time.getHours() >= 12 ? 'PM' : 'AM';
      this.currentTime = this.formatTime(this.time);
    }, 1000); // Update every second
  }

  switchFirm(firm: any) {
    //console.log("Switching to firm:", firm);

    if (this.switchingFirmId) {
      return; // Prevent multiple switches at once
    }

    this.switchingFirmId = firm.id; // Track which firm is loading

    let email = localStorage.getItem("AAM_email");
    if (email) {
      email = email.replace(/"/g, "");
    }

    let payload = {
      email: email,
      userid: firm.id,
      plan: this.product || "lauditor"
    };

    //console.log('Switch firm payload:', payload);
    this.httpService.sendPostRequest(URLUtils.switchFirm, payload, "", true).subscribe({
      next: (res: any) => {
        //console.log("Switch firm response:", res);

        if (res && res.data) {
          // Update all localStorage values with new firm data
          localStorage.setItem('TOKEN', res.data.access_token)
          localStorage.setItem('REFRESH_TOKEN', res.data.refresh_token)
          localStorage.setItem('name', res.data.name);
          localStorage.setItem('role', res.data.role);
          localStorage.setItem('isadmin', res.data.admin || 'false');
          localStorage.setItem('jid', res.data.uid);
          localStorage.setItem('firm_name', res.data.firm_name);
          localStorage.setItem('user_id', res.data.user_id || res.data.id);
          localStorage.setItem('user_allowed', JSON.stringify(res['data'].user_allowed));
          // localStorage.setItem('user_email', JSON.stringify(res['data'].email));
          localStorage.setItem('isPaidSub', JSON.stringify(res['data']['subscription']['is_active'])); //Storing groups in localStorage

          if (res.data.groups) {
            localStorage.setItem('user_groups', JSON.stringify(res.data.groups));
          }

          // if (res.data.firms && Array.isArray(res.data.firms)) {
          //   localStorage.setItem('user_firms', JSON.stringify(res.data.firms));
          // }

          // Update component properties
          this.firmName = res.data.firm_name;
          this.name = res.data.name;
          this.roleId = res.data.user_id || res.data.id;
          this.currentFirmId = res.data.user_id || res.data.id;

          // Update category & solo flag if returned by switch response
          if (res.data.category) {
            localStorage.setItem('category', res.data.category);
            this.category = res.data.category;
            this.isSoloCategory = this.category === 'solo';
          }

          this.initalize_roles();
          this.switchingFirmId = '';
          this.isCardVisible = false;
          //console.log("Firm switched successfully. Reloading...");

          setTimeout(() => {
            window.location.href = '/grid';
          }, 100);
        }
      },
      error: (error) => {
        //console.error("Error switching firm:", error);
        this.switchingFirmId = '';
        alert("Failed to switch firm. Please try again.");
      },
    });
  }

  // getUnreadCount() {
  //   this.httpService
  //     .sendGetRequest(URLUtils.getNotifications)
  //     .subscribe((res: any) => {
  //       if (res && res.data && res.data.notifications) {
  //         this.notificationCount = res.data.notifications.filter(
  //           (n: any) => n.status === 'unread'
  //         ).length;
  //       } else {
  //         this.notificationCount = 0;
  //       }
  //     });
  // }

  getUnreadCountFromAPI() {
    this.httpService.sendGetRequest(URLUtils.getNotifications).subscribe((res: any) => {
      const count = res.data.notifications.filter((n: any) => n.status === 'unread').length;
      this.httpService.updateUnreadCount(count); // Push to shared subject
    });
  }

  // Returns the correct nav items array based on the active product
  // get activeNavItems(): any[] {
  //   console.log('Current product:', this.product);
  //   switch (this.product) {
  //     case 'corporate': return this.navCorporate;
  //     case 'content':   return this.navContent;
  //     case 'connect':   return this.navConnect;
  //     default:          return this.navItem; // 'lauditor' and fallback
  //   }
  // }


  // Mobile menu methods
  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu() {
    this.isMobileMenuOpen = false;
  }

  // Sidebar toggle methods
  toggleSidebar() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
    if (this.isSidebarCollapsed) {
      this.expandedItem = null;
    }
    // Save preference to localStorage
    localStorage.setItem('sidebarCollapsed', JSON.stringify(this.isSidebarCollapsed));
  }

  toggleSubmenu(itemId: string) {
    // Allow submenu toggle when the mobile/tablet drawer is open,
    // even if the desktop sidebar is in its collapsed (icon-only) state.
    if (this.isSidebarCollapsed && !this.isMobileMenuOpen) {
      return; // Don't toggle submenu on desktop icon-only mode
    }
    this.expandedItem = this.expandedItem === itemId ? null : itemId;
  }

  // Tooltip methods
  showTooltip(event: MouseEvent | FocusEvent, text: string) {
    // Only show tooltip in desktop icon-only mode
    if (!this.isSidebarCollapsed || this.isMobileMenuOpen) {
      return;
    }

    const target = event.currentTarget as HTMLElement;
    if (!target) {
      return;
    }

    const rect = target.getBoundingClientRect();

    this.tooltipText = text;
    this.tooltipTop = rect.top + rect.height / 2;
    this.tooltipLeft = rect.right + 10;
    this.tooltipVisible = true;
  }



  hideTooltip() {
    this.tooltipVisible = false;
  }

  // Submenu popover methods
  showSubmenuPopover(event: MouseEvent, title: string, items: any[]) {
    // Only show popover in desktop icon-only mode
    if (!this.isSidebarCollapsed || this.isMobileMenuOpen) {
      return;
    }

    // Clear any existing timeout
    if (this.popoverTimeout) {
      clearTimeout(this.popoverTimeout);
    }

    const target = event.currentTarget as HTMLElement;
    const rect = target.getBoundingClientRect();

    this.popoverTitle = title;
    this.popoverItems = items;
    this.popoverTop = rect.top;
    this.popoverLeft = rect.right + 10;
    this.submenuPopoverVisible = true;

    // Hide tooltip when showing popover
    this.tooltipVisible = false;
  }

  hideSubmenuPopover() {
    // Delay hiding to allow mouse to move to popover
    this.popoverTimeout = setTimeout(() => {
      this.submenuPopoverVisible = false;
    }, 200);
  }

  keepPopoverVisible() {
    // Cancel hide timeout when mouse enters popover
    if (this.popoverTimeout) {
      clearTimeout(this.popoverTimeout);
    }
  }

  navigateToSubmenu(item: any) {
    const queryParams = item.profileType ? { profileType: item.profileType } : {};
    this.router.navigate([item.route], { queryParams });
    // The NavigationEnd subscription will set categoryName, activeItemId, and
    // localStorage authoritatively — no need to duplicate it here.
    // Close the popover and drawer.
    this.submenuPopoverVisible = false;
    this.isMobileMenuOpen = false;
  }


  getUnreadCount() {
    this.httpService.sendGetRequest(URLUtils.getNotifications).subscribe({
      next: (res: any) => {
        if (res && res.data && res.data.notifications) {
          this.notificationCount = res.data.notifications.filter((n: any) => n.status === 'unread').length;
        } else {
          this.notificationCount = 0;
        }
      },
      error: () => {
        this.notificationCount = 0;
      }
    });
  }

  //   getButtonActive(buttonName:any){
  //     const categoryList=document.getElementsByClassName("left-menu-icon");
  //     //console.log("className  "+ JSON.stringify(categoryList));
  //     for(let i=0;i<categoryList.length;i++){
  //       if(categoryList[i].classList.contains(buttonName)){
  //         categoryList[i].classList.add('active');
  //         //console.log("className  "+ JSON.stringify( categoryList[i].classList));
  //       }else{
  //         categoryList[i].classList.remove('active');
  //         //console.log("className  "+ JSON.stringify( categoryList[i].classList));
  //       }
  //     }
  // }

  /** Returns the display name for a nav item.
   *  When the current role is AAM, the "Profile" item is shown as "Firm Profile".
   */
  getNavItemName(item: any): string {
    if (item.id === 'profile' && this.userRole === 'AAM') {
      return 'Firm Profile';
    }
    return item.name;
  }
}